module.exports = __webpack_public_path__ + "static/media/3.63a3dbe9.svg";